/**
 * This method normalize the query to make it matchable by our stub HTTP server in test environment.
 */
export function buildGroqQuery(rawQuery: string): string {
  return rawQuery.replace(/(\r\n|\n|\r)/gm, "").replace(/(\s+)/gm, " ");
}
